<template>
    <v-avatar :style="{'border-color': color}" class="card-box-shadow" :class="$scopedSlots.icon ? 'icon-avatar' : 'avatar-border'" data-testid="userAvatar" :size="size">
        <template v-if="$scopedSlots.icon">
            <slot name="icon"></slot>
        </template>
        <v-img v-else
            :src="resolvedSrc"
            :alt="alt"
            :width="size"
            :height="size"
            contain
            max-width="100%"
            @error="handleImageError"
            :aspect-ratio="1">
        </v-img>
    </v-avatar>
</template>

<script>
    // https://cdn.vuetifyjs.com/images/john.jpg
    export default {
        name: 'Avatar',
        props: {
            src: String,
            alt: {
                type: String,
                default: ""
            },
            color: {
                type: String,
                default: '#002B49'
            },
            size: {
                type: String,
                default: "54"
            },
            defaultImage: {
                type: String,
                default: null
            }
        },
        data () {
            return {
                standardDefaultImage: '/images/placeholder-profile.png',
                resolvedSrc: null
            };
        },
        computed: {
            fallbackImageSource () {
                return this.defaultImage || this.standardDefaultImage;
            }
        },
        watch: {
            src: {
                immediate: true,
                handler () {
                    this.resetResolvedSrc();
                }
            },
            defaultImage () {
                this.resetResolvedSrc();
            }
        },
        methods: {
            resetResolvedSrc () {
                this.resolvedSrc = this.src || this.fallbackImageSource;
            },
            handleImageError () {
                if (this.resolvedSrc !== this.fallbackImageSource) {
                    if (this.$scopedSlots.icon) {
                        this.resolvedSrc = null;
                    } else {
                        this.resolvedSrc = this.fallbackImageSource;
                    }
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import '@/style.scss';
    .avatar-border {
        border: 4px solid $amwins-blue;
    }
    .icon-avatar {
        background-color: $amwins-blue;
    }
    ::v-deep .v-avatar img, .v-avatar svg, .v-avatar .v-icon, .v-avatar .v-image, .v-avatar .v-responsive__content {
        display: block;
    }
</style>
